import React from "react";
import { Card, Col, Row, Statistic } from "antd";

export interface AnalyticsMetric {
  key: string;
  title: string;
  value: number | string;
  suffix?: string;
  onClick?: () => void;
}

interface AnalyticsMetricGridProps {
  metrics: AnalyticsMetric[];
  loading?: boolean;
}

const AnalyticsMetricGrid: React.FC<AnalyticsMetricGridProps> = ({ metrics, loading = false }) => (
  <Row gutter={[16, 16]}>
    {metrics.map((metric) => (
      <Col xs={12} md={6} key={metric.key}>
        <Card
          size="small"
          hoverable={!!metric.onClick}
          onClick={metric.onClick}
          style={{ cursor: metric.onClick ? "pointer" : "default" }}
        >
          <Statistic title={metric.title} value={metric.value} suffix={metric.suffix} loading={loading} />
        </Card>
      </Col>
    ))}
  </Row>
);

export default AnalyticsMetricGrid;
